/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

	// Use this variable to set up the common and page specific functions. If you
	// rename this variable, you will also need to rename the namespace below.
	var Muchachos = {
		// All pages
		'common': {
			init: function() {
				// JavaScript to be fired on all pages
			},
			scroll: function() {
				// JavaScript to be fired on scroll event
			},
			resize: function() {
				// JavaScript to be fired on resize event
				nav_resize_handle();
			},
			finalize: function() {
				// JavaScript to be fired on all pages, after page specific JS is fired
				handle_menu_click();
				handle_hash_link();
				handle_members_search_ajax();
				handle_members_search_ajax_onchange();
				handle_articles_filters_redirection();
				scrollToHash();


			},
		},
		// Home page
		'homepage': {
			init: function() {
				// JavaScript to be fired on home page
			},
			resize: function() {
				// JavaScript to be fired on home page resize event
			},
			finalize: function() {
				// JavaScript to be fired on the home page, after the init JS
			}
		},

	};

	// The routing fires all common scripts, followed by the page specific scripts.
	// Add additional events for more control over timing e.g. a finalize event
	var UTIL = {
		fire: function(func, funcname, args) {
			var fire;
			var namespace = Muchachos;
			funcname = (funcname === undefined) ? 'init' : funcname;
			fire = func !== '';
			fire = fire && namespace[func];
			fire = fire && typeof namespace[func][funcname] === 'function';

			if (fire) {
				namespace[func][funcname](args);
			}
		},
		loadEvents: function() {
			// Fire common init JS
			UTIL.fire('common');

			// Fire page-specific init JS, and then finalize JS
			$.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
				UTIL.fire(classnm);
				UTIL.fire(classnm, 'finalize');
			});

			// Fire common finalize JS
			UTIL.fire('common', 'finalize');
		},

		// Fire resize JS
		resizeEvents: function() {

			// Fire page-specific init JS, and then finalize JS
			$.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
				UTIL.fire(classnm, 'resize');
			});

			// Fire common finalize JS
			UTIL.fire('common', 'resize');

		},
		// Fire resize JS
		scrollEvents: function() {

			// Fire page-specific init JS, and then finalize JS
			$.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
				UTIL.fire(classnm, 'scroll');
			});

			// Fire common finalize JS
			UTIL.fire('common', 'scroll');

		},
	};

	// Throttles for resource-intensive events
	var resizeTimer,scrollTimer;

	// Events
	$(document).ready(UTIL.loadEvents);

	$(window).resize(function(e) {
		clearTimeout(resizeTimer);
	    resizeTimer = setTimeout(function() {
			UTIL.resizeEvents();
	    }, 50);
	});

	$(window).scroll(function(e) {
		clearTimeout(resizeTimer);
	    resizeTimer = setTimeout(function() {
			UTIL.scrollEvents();
	    }, 50);
	});




	// ----------------------------- //
	// ---- FUNCTIONS GOES HERE ---- //
	// ----------------------------- //


	// // Quick scroll to snippet
	// function scroll_to( _target, _offset, _duration, _this ) {
//
	// 	if ( _offset === 'undefined' )
	// 		_offset = 0;
//
	// 	if ( _duration === 'undefined' )
	// 		_duration = 500;
//
	// 	// Add header to our equation
	// 	_offset = -$('[role="banner"]').outerHeight() + _offset;
//
	// 	if ( _target == '#next' ) {
	// 		_target = _this.closest('section').next('section');
	// 		_destination = $(_target).offset().top + _offset;
	// 	} else {
	// 		_destination = $(_target).offset().top + _offset;
	// 	}
	//
	//     $('html, body').animate({
	//         scrollTop: _destination
	//     }, _duration);
//
	// }




    //=======================================
    // Google Analytics events
    //=======================================
    function ga_event_outbound_links(event) {

   		if (typeof ga == 'function') {
			var target = $(this).attr('href');
    		ga('send', 'event', 'Outbound Links', target);
    	}
		else {
			console.log('Analytics deactivated');
		}
    }



    //=======================================
    // Menu handling
    //=======================================
    function handle_menu_click(event) {

   		$('.nomnom').click(function (event) {
			event.preventDefault();

			$('.mobile-navigation').toggleClass('open');
			$('.nomnom').toggleClass('is-active');


			if ($('.mobile-navigation').hasClass('open')) {
				$('body, html').addClass('no-scroll');
			}
			else {
				$('body, html').removeClass('no-scroll');
			}
		});
    }


	//=======================================
    // Menu window resize handling
    //=======================================
    function nav_resize_handle() {
		if($('body, html').hasClass('no-scroll')) {
			$('.mobile-navigation').removeClass('open');
			$('body, html').removeClass('no-scroll');
			$('.nomnom').removeClass('is-active');
		}
	}


	// Quick scroll to snippet
	function scroll_to( _target, _offset, _duration, _this ) {

		if ( typeof _offset == "undefined" )
			_offset = 0;

		if ( typeof _duration == "undefined" )
			_duration = 500;


		// Add header to our equation
		_offset = -$('[role="banner"]').outerHeight() + _offset;

		// Analyze our _target
		if ( _target instanceof jQuery ) {
			_destination = _target.offset().top;
		}

		else if ( _target == '#next' ) {
			_target = _this.closest('section').next('section');
			_destination = $(_target).offset().top;
		}

		else {
			_destination = $(_target).offset().top;
		}

		_destination = _destination + _offset;

    $('html, body').animate({
        scrollTop: _destination
    }, _duration);

	}


	function init_scrollTop_hash(url) {
		var hash = url;

		if(hash) {
			var scrollTo_element = $(hash);
			if(scrollTo_element.length > 0) {
				scroll_to( scrollTo_element, -50, 700 );
			}
		}
	}

	function handle_hash_link() {
		$('a[href*="#"]').click(function (event) {
			url = $(this).attr('href');
			init_scrollTop_hash(url);
		});
	}


	function handle_members_search_ajax() {
		$('form').on('submit', function() {

			event.preventDefault();

            var host = window.location.protocol + "//" + window.location.host;
            var url = host + "/repertoire/";
            history.pushState(undefined, '', url);

			var select_1 = $('select[name="member_secondary_activity_branch"]');
			var select_2 = $('select[name="member_area"]');

			var select_1_name = select_1.attr('name');
			var select_2_name = select_2.attr('name');

			var select_1_selected_option = select_1.find(":selected").attr('value');
			var select_2_selected_option = select_2.find(":selected").attr('value');

			var url = $(this).attr('action');

			url += "?" + select_1_name + "=" + select_1_selected_option;
			url += "&" + select_2_name + "=" + select_2_selected_option;

			$('#directory-members').hide();

			$( '.ajax-loader' ).fadeIn(300);

			$.ajax({
				url: url,
				type: 'GET',
				error: function() {
					$('#directory-members').append('<p>An error has occurred</p>');
				},
				success: function(data) {
					$('#directory-members').html($(data).find('#directory-members').contents());

					setTimeout(function(){
						$('#directory-members').fadeIn(300);
					}, 2000);
				},
			});

			$( document ).ajaxStop(function() {
				setTimeout(function() {
					$( '.ajax-loader' ).hide();
				}, 2000);
			});
		});
	}


	function handle_members_search_ajax_onchange() {
		var selects = $('.search-directory').children('.select').children('select');
		var submit_button = $('.submit-btn');

		// Initialize the select change hihi
		selects.each(function(){
			$(this).on('change', function() {
				if(submit_button.hasClass('clickable')) {
				}
				else {
					submit_button.addClass('clickable');
				}
			});
		});

	}

	function handle_articles_filters_redirection() {
		var select = $('.el-patron').find('select[name="categories"]');

		select.each(function(){
			$(this).on('change', function() {
				var url = $(this).find(":selected").attr("value");
				var name = $(this).find(":selected").attr("name");

				if($('body').hasClass('blog')) {
					$('#articles-items').hide();

					$('.featured-item').hide();

					$( '.ajax-loader' ).fadeIn(300);

					$.ajax({
						url: url,
						type: 'GET',
						error: function() {
							$('#articles-items').append('<p>An error has occurred</p>');
						},
						success: function(data) {
							$('#articles-items').html($(data).find('#articles-items').contents());

							setTimeout(function(){
								if(name == "all") {
									$('.featured-item').fadeIn(300);
								}

								$('#articles-items').fadeIn(300);
							}, 2000);
						},
					});

					$( document ).ajaxStop(function() {
						setTimeout(function() {
							$( '.ajax-loader' ).hide();
						}, 2000);
					});
				}
				else {
					if($('body').hasClass('archive')) {
						window.location.replace(url);
					}
				}
			});
		});

	}


    function scrollToHash() {
        if (window.location.hash) {
            var $hash = window.location.hash.substring(1);

            $hash = $hash.replace('#', '');

            scrollTo($hash);
        }

        $('a').on('click', function(event) {
			var url = $(this).attr('href');
			var hash_index = url.indexOf("#");
			var clicked_hash = url.substr(hash_index);
			var scroll_delay = 0;

			clicked_hash = clicked_hash.replace("#", "");

			if(clicked_hash !== "" && $('[data-id="'+ clicked_hash +'"]').length > 0) {
				event.preventDefault();
				setTimeout(function() {
					scrollTo(clicked_hash);
				}, scroll_delay);
			}
		});
    }

    function scrollTo($target) {

        if (typeof $target !== 'undefined') {

            // Check for data-id first
            var $element = $('[data-id="' + $target + '"]');

            // Then check of trad id
            if ($element.length === 0) {
                $element = $('#' + $target);
            }

            // Scroll if $element exists
            if ($element.length !== 0) {

                setTimeout(function () {
                    $('html, body').animate({
                        scrollTop: $element.offset().top - 150
                    }, 500);
                }, 300);
            }
        }
    }

})(jQuery); // Fully reference jQuery after this point.
